import React, { useState } from "react";
import { motion } from "framer-motion";
import { animationValues, transitionValues } from "../utils/pageTransitions";
import logo from "../assets/images/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { adminLogin, forgot_password } from "../redux/actions/adminActions";
import { connect } from "react-redux";
import Spinner from "../components/reusables/spinner";
import InputField from "../components/reusables/input";
import "../styles/auth.css";

function ForgotPassword({ forgot_password, accessToken }) {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  const [formData, setData] = useState({ email: "" });

  const handleChange = (e) => {
    setData({
      ...formData,
      email: e.target.value,
    });
  };

  const handleLoading = () => {
    setIsLoading(true);
  };

  const done = () => {
    setIsLoading(false);
  };

  const submit = (e) => {
    e.preventDefault();
    handleLoading();
    forgot_password(formData, navigate, () => done());
  };

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationValues}
      transition={transitionValues}
    >
      <div className="fullHeight admin">
        <div className="formHolder container center">
          <div className="content vAlign">
            <img src={logo} alt="" className="mAuto pb-5" />
            <div className="authCard alignOnly">
              <div className="w-100">
                <h2 className="sectionHead--small textIsBold pt-3">
                  Forgot Password
                </h2>

                <form className="pt-3" onSubmit={submit}>
                  <div className="pt-2 pb-2">
                    <InputField
                      type="text"
                      placeholder="Email Address"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>

                  <div className=" mobileBlock">
                    <div className="pt-3">
                      {isLoading ? (
                        <button className="btn__filled textIsBold center w-100">
                          Please Wait {""}
                          <Spinner />
                        </button>
                      ) : (
                        <button className="btn__filled textIsBold w-100">
                          Reset Password
                        </button>
                      )}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

const mapStateToProps = (state) => ({
  accessToken: state.admin.token,
});

const mapDispatchToProps = (dispatch) => ({
  forgot_password: (data, navigator, done) =>
    dispatch(forgot_password(data, navigator, done)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
